var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26241 13.4697C9.67241 13.4697 10.8024 14.6107 10.8024 16.0307V19.4397C10.8024 20.8497 9.67241 21.9997 8.26241 21.9997H4.88241C3.48241 21.9997 2.34241 20.8497 2.34241 19.4397V16.0307C2.34241 14.6107 3.48241 13.4697 4.88241 13.4697H8.26241ZM19.8025 13.4697C21.2025 13.4697 22.3425 14.6107 22.3425 16.0307V19.4397C22.3425 20.8497 21.2025 21.9997 19.8025 21.9997H16.4225C15.0125 21.9997 13.8825 20.8497 13.8825 19.4397V16.0307C13.8825 14.6107 15.0125 13.4697 16.4225 13.4697H19.8025ZM8.26241 2C9.67241 2 10.8024 3.15 10.8024 4.561V7.97C10.8024 9.39 9.67241 10.53 8.26241 10.53H4.88241C3.48241 10.53 2.34241 9.39 2.34241 7.97V4.561C2.34241 3.15 3.48241 2 4.88241 2H8.26241ZM19.8025 2C21.2025 2 22.3425 3.15 22.3425 4.561V7.97C22.3425 9.39 21.2025 10.53 19.8025 10.53H16.4225C15.0125 10.53 13.8825 9.39 13.8825 7.97V4.561C13.8825 3.15 15.0125 2 16.4225 2H19.8025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreWhite);
export default __webpack_public_path__ + "static/media/explore-white.6cb028d82a78714942abcd9a2573d784.svg";
export { ForwardRef as ReactComponent };